import { render, staticRenderFns } from "./PhoneConfirmation.vue?vue&type=template&id=377d8a2a&scoped=true&"
import script from "./PhoneConfirmation.vue?vue&type=script&lang=js&"
export * from "./PhoneConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PhoneConfirmation.vue?vue&type=style&index=0&id=377d8a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d8a2a",
  null
  
)

export default component.exports